import React from 'react'

type Props = {}

const User = (props: Props) => {
    return (
        <svg
            width="27"
            height="27"
            viewBox="0 0 27 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        {...props}>
            <path
                d="M21.8067 22.8915V20.721C21.8067 19.5696 21.3494 18.4655 20.5352 17.6514C19.7211 16.8372 18.617 16.3799 17.4656 16.3799H8.78347C7.63214 16.3799 6.52797 16.8372 5.71386 17.6514C4.89975 18.4655 4.44238 19.5696 4.44238 20.721V22.8915"
                stroke="#EE0033"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1243 12.0386C15.5218 12.0386 17.4654 10.095 17.4654 7.69753C17.4654 5.30002 15.5218 3.35645 13.1243 3.35645C10.7268 3.35645 8.7832 5.30002 8.7832 7.69753C8.7832 10.095 10.7268 12.0386 13.1243 12.0386Z"
                stroke="#EE0033"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default User